import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { PushModule } from 'rev-shared/push/Push.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { UtilAngularModule } from 'rev-shared/util/UtilAngular.Module';
import { VBrickSharedPublicVideoPasswordModule } from 'rev-shared/media/publicVideoPassword/PublicVideoPassword.Module';
import { VbrickSharedMediaModule } from 'rev-shared/media/Media.Module';
import { VideoPlayerAngularModule } from 'rev-shared/videoPlayer/VideoPlayerAngular.Module';
import { VideoPlaylistModule } from 'rev-shared/media/videoPlaylist/VideoPlaylist.Module';

import { EmbedVideoModule } from 'rev-embed/video/EmbedVideo.Module';
import { BrandingAngularModule } from 'rev-portal/branding/BrandingAngular.Module';

import { EmbedPlaylistComponent, EmbedPlaylistSliderComponent } from './EmbedPlaylist.Component';
import { EmbedPlaylistGridComponent } from './EmbedPlaylistGrid.Component';

@NgModule({
	declarations: [
		EmbedPlaylistComponent,
		EmbedPlaylistGridComponent,
		EmbedPlaylistSliderComponent

	],
	exports: [
		EmbedPlaylistComponent,
		EmbedPlaylistGridComponent,
		EmbedPlaylistSliderComponent
	],
	imports: [
		ButtonsAngularModule,
		BrandingAngularModule,
		CommonModule,
		DateAngularModule,
		DirectivesAngularModule,
		EmbedVideoModule,
		PushModule,
		SpinnerAngularModule,
		TooltipModule,
		TranslateModule,
		UtilAngularModule,
		UIRouterModule,
		VbrickSharedMediaModule,
		VBrickSharedPublicVideoPasswordModule,
		VideoPlaylistModule,
		VideoPlayerAngularModule
	]
})
export class EmbedPlaylistModule { }
